import api_url from "../api_url";

export const login = async (email, password) => {
    try {
        const response = await fetch(`${api_url}/api/login`, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
            },
            body: JSON.stringify({ email, password }),
        });

        const data = await response.json();

        if (response.ok) {
            localStorage.setItem('auth', JSON.stringify(data));
            localStorage.setItem('accessToken', data.accessToken);
            localStorage.setItem('refreshToken', data.refreshToken);

            return {
                success: true,
                message: data.message,
                data,
            };
        } else {
            return {
                success: false,
                message: data.message || 'Login failed',
            };
        }
    } catch (error) {
        return {
            success: false,
            message: 'An error occurred while logging in',
        };
    }
};
